<acs-alert
  *ngFor="let msg of messages; trackBy: getIdentifierForIterableItem"
  class="alert"
  [type]="msg.messageType"
  (close)="closeAlert($event)"
  [closable]="msg.closable"
  [message]="msg.title"
  role="alert"></acs-alert>
